/**
 * Detect the gateway "pairing required" handshake rejection.
 *
 * When a stored pairing token has been revoked (or was never issued), the
 * gateway answers `connect` with an error whose message contains
 * "pairing required" / "pair this device" / similar. We key off the
 * substring rather than exact-match because the gateway wording is not
 * guaranteed stable across versions.
 */
export function isPairingRequiredError(
  errorMessage: string | null | undefined,
): boolean {
  if (errorMessage == null) return false;
  return /\bpair(ing)?\b/iu.test(errorMessage);
}

/**
 * Detect a gateway token mismatch — the stored token no longer matches the
 * gateway (e.g. the gateway was rotated or restarted). The user must paste
 * the new token from the OpenClaw dashboard.
 */
export function isTokenMismatchError(
  errorMessage: string | null | undefined,
): boolean {
  if (errorMessage == null) return false;
  return /token.mismatch/iu.test(errorMessage);
}
